<script lang="ts" setup>
import type { PropType } from 'vue'

import type { ShipType } from '@/stores/type/ship.type'
import ShipChart from '@/components/chart/ShipChart.vue'

defineProps({
	ship: { type: [Object, null] as PropType<ShipType | null>, required: true },
	chartEvent: { type: String as PropType<string>, required: true },
	chartRef: { type: String as PropType<string>, required: true }
})
</script>

<template>
	<div class="fill-height">
		<template v-if="ship?.shipcontour_set?.length">
			<ShipChart :ship="ship" :chart-event="chartEvent" :chart-ref="chartRef" />
		</template>
		<template v-else>
			<div class="fill-height" style="align-content: center; text-align: center">
				<span>No plan view of ship</span>
			</div>
		</template>
	</div>
</template>
